import React, { useEffect } from 'react';

import ChangePassword from './ChangePassword';
import AccountSettings from './AccountSettings';
import BilingAddress from './BilingAddress';
import ShippingAddress from './ShippingAddress';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerProfileThunk } from '../../../../Website/redux/customerSlice';
import Myprofile from '../../Pages/myprofile/Myprofile';

const ProfileBody = () => {
    const { customer, refresh, loading } = useSelector((state) => state.customer)


    console.log(customer);


    if (loading) {
        return <div>please wait...</div>
    }

    return (
        <Myprofile>
            <div style={{ display: 'flex', flexDirection: 'column', gap: "20px", width: "100%" }}>

                <AccountSettings customer={customer} />

                <ChangePassword />

                <BilingAddress />

                <ShippingAddress />

            </div >
        </Myprofile>
    );
};

export default ProfileBody;
